import { configureStore } from '@reduxjs/toolkit';
import appMetadataReducer from '../app/AppMetadataSlice';
import corpSegmentReducer from '../store/slices/corpSegmentSlice';
import xPTMapperReducer from '../store/slices/xPTMapperSlice';
import accessAndAuthorizationReducer from '../features/business-group/access-authorization/redux/userAuthorizationSlice';
import businessGroupReducer from '../features/business-group/businessGroupSlice';
import planningCycleReducer from '../features/planning-cycle/redux/planningCycleSlice';
import forecastTemplateReducer from '../features/business-group/forecast-template/redux/forecastTemplateSlice';
import poTaggingReducer from '../features/po-tagging/POTaggingSlice';
import dmmReducer from 'src/store/slices/dmmSlice';
import accessRequestReducer from '../features/access-request/redux/accessRequestSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import xvtForecastReducer from '../features/business-group/xvt-planning/redux/xvtForecastSlice';
import { listenerMiddleware } from './listenerMiddleware';
// Imported for its side effect: registers the dismissed-ids persistence listener.
import '../features/notifications/notificationsPersistence';

export const makeStore = () =>
  configureStore({
    reducer: {
      xptAppMetadataStore: appMetadataReducer,
      xptAccessAndAuthorizationStore: accessAndAuthorizationReducer,
      corpSegmentsStore: corpSegmentReducer,
      businessGroupStore: businessGroupReducer,

      xPTMappingStore: xPTMapperReducer,
      planningCycleStore: planningCycleReducer,
      forecastTemplateStore: forecastTemplateReducer,
      poTaggingStore: poTaggingReducer,
      dmmStore: dmmReducer,
      accessRequestStore: accessRequestReducer,
      notificationsStore: notificationsReducer,
      // Registered unconditionally and inert today (nothing in app init dispatches xVT work); an
      // app-init xVT thunk would bypass both xVT gates, since neither one sits on the store.
      xvtForecastStore: xvtForecastReducer
    },
    // Listener middleware is prepended so its effects observe an action before the rest of the
    // chain, per the RTK guidance.
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false
      }).prepend(listenerMiddleware.middleware),
    devTools: process.env.NODE_ENV === 'dev'
  });

export const store = makeStore();

// Types for RootState and AppDispatch are useful for TypeScript support throughout the app, especially for type-safe useSelector and useDispatch hooks.
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
